module.exports = __webpack_public_path__ + "img/2.95451d6b.jpg";